import { Injectable, OnDestroy, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
import { map, skipWhile } from 'rxjs/operators';
import { Http } from '@angular/http';


@Injectable()
export class UserService implements OnDestroy, OnInit {
  public user = new BehaviorSubject<any>({});
  public userId: string;
  private followers = [];
  private ipAddress: any;
  private _http: Http;
  private followUser = new BehaviorSubject<any>([]);
  subsc = new Subscription();
  constructor(private afs: AngularFirestore) {


    this.setUser(localStorage.getItem("currentUserId"));



  }
  fillFollowers() {
    this.subsc.add(this.afs.collection('users').doc(this.userId)
      .collection('followIng').valueChanges().subscribe(data => {
        this.followers = data;
        this.followUser.next(data);

      }));

  }
  ngOnInit() {



  }
  getFollowers() {
    return this.followUser.asObservable();
  }
  getFollowing() {
    return this.afs.collection('users').doc(this.userId).collection('followIng').valueChanges();
  }
  getUid() {
    return this.userId;
  }
  getUser(): Observable<any> {

    return this.user.asObservable();
  }
  userLog(type, ipAddress) {

    this.afs.collection('logs').add({
      userId: this.getUid(),
      date: new Date(),
      type: type,
      ipAddress: ipAddress,
      url: 'bigadvice.com'
    });

  }




  setUser(userId) {

    if (userId) {
      this.userId = userId;
      this.subsc.add(this.afs.collection('users').doc(userId).snapshotChanges().pipe(map(actions => {
        return {
          id: actions.payload.id,
          ...actions.payload.data()
        }
      })).subscribe(user => {


        this.user.next(user);
      }));
      this.fillFollowers();
      // this.afs.collection('users').doc(userId).valueChanges().subscribe(user=>{
      //   this.user.next(user);
      // })
    }
  }
  clearUser() {
    localStorage.clear();
    this.userId = null;
    this.user.next({});
  }
  getShortUser() {
    return firebase.auth().currentUser;
  }
  sendEmail(email: any) {
    return firebase.database().ref("sendEmail/" + email.userId).set(email);
  }
  ngOnDestroy() {
    this.subsc.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/user.service.ts